import { mapState } from "vuex";
import { windowResized, handleNavOnScroll } from "./windowEventListeners";

export const comonFunctions = {
  mixins: [windowResized, handleNavOnScroll],
  data() {
    return {
      showCarLook: true,
      showCarOptions: false,
      model: "",
      staticText: {
        motorLabels: ["motor", "motores"],
        versionLabels: ["versão", "versões"],
        dsgExtLabels: ["Design Exterior", "cores"],
        dsgIntLabels: ["Design Interior", "cores"],
      },
    };
  },
  beforeDestroy() {
    document.body.classList.remove("isActive");
  },
  computed: {
    ...mapState(["dataBO", "resumeData"]),
  },
  methods: {
    displayCarOptions() {
      this.showCarLook = !this.showCarLook;
      this.showCarOptions = !this.showCarOptions;

      if (this.isMobile) document.body.classList.toggle("isActive");
    },
  },
};

export const formatContent = {
  methods: {
    format_thousands(value) {
      if (!value) return false;
      const rounded = Math.round(value * 100) / 100;
      return rounded
        .toString()
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
